/**
 * Kiosk management capabilities confirmed against arkhrmsapi kiosk.routes.js.
 *
 * Admin (SETTINGS_VIEW / SETTINGS_UPDATE):
 * - GET/POST /kiosks
 * - GET /kiosks/:kioskId
 * - POST /kiosks/:kioskId/activation-token
 * - POST /kiosks/:kioskId/deactivate
 * - GET /kiosks/:kioskId/activation-status
 *
 * Public / device (no admin JWT):
 * - POST /kiosks/activate
 * - POST /kiosks/auth/refresh
 * - GET /kiosks/activation-status?activationToken=
 */
export const KIOSK_CAPABILITIES = {
  list: true,
  register: true,
  details: true,
  generateActivationToken: true,
  deactivate: true,
  activationStatus: true,
  deviceActivate: true,
  deviceRefresh: true,
} as const;

export function getKioskModuleCapabilities(permissions: readonly string[]) {
  const canView = permissions.includes('SETTINGS_VIEW');
  const canUpdate = permissions.includes('SETTINGS_UPDATE');
  return {
    canViewKiosks: canView && KIOSK_CAPABILITIES.list,
    canRegisterKiosk: canUpdate && KIOSK_CAPABILITIES.register,
    canManageKiosk: canUpdate && KIOSK_CAPABILITIES.generateActivationToken,
    canDeactivateKiosk: canUpdate && KIOSK_CAPABILITIES.deactivate,
  };
}
